<template>
  <b-container class="d-flex flex-column v2_font_Montserrat">
    <div class="d-flex align-items-center justify-content-between report-heading">
      <span
          class="v2_font_size_24 v2_font_weight_extra_light text-uppercase ml-2"
      >
        Phairify
      </span>
      <span
          class="v2_font_size_20 v2_font_weight_extra_light text-uppercase ml-2"
      >
       {{ (study || {}).title }}
      </span>
      <span
          class="v2_font_size_24 v2_font_weight_extra_light text-uppercase mr-2"
      >
        {{ dateValue }}
      </span>
    </div>

    <b-row class="mt-3">
      <b-col md="12" class="px-2">
        <b-card class="p-1 border-color-pdf">
          <p class="mb-3 v2_font_weight_bol text-uppercase font-1stp-pdf v3_color_teal pl-2">
            Study Design
          </p>
          <div class="d-flex justify-content-between">
            <div class="pl-2">
              <p>Medical Specialty Society: {{ userSocietyName }}</p>
              <p>Specialty: {{ userSpecialty }}</p>
              <p>Subspecialty: {{ userSubspecialty }}</p>
            </div>
            <div class="pl-2">
              <p>Membership Category: {{ membershipTypeName }}</p>
              <p>Study Sample Model: {{ (study || {}).studySampleModel }}</p>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col md="12" class="px-2">
        <b-card class="p-1 border-color-pdf">
          <p>
            <span class="mb-3 v2_font_weight_bol text-uppercase font-1stp-pdf v3_color_teal pl-2">Measure:</span>
            <span> {{ measure }} </span>
          </p>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-3 mb-3">
      <b-col md="12" class="px-2">
      <b-card class="p-1 border-color-pdf">
        <p class="mb-3 v2_font_weight_bol text-uppercase font-1stp-pdf v3_color_teal pl-2">
          Filters
        </p>
        <div v-if="!$slots.filters">
          Filters are not specified
        </div>
        <slot name="filters" />
      </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
export default {
  name: "ReportMarkdownHeading",
  props: {
    measure: String,
    study: Object,
    resultTitles: Array
  },
  computed: {
    user: function () {
      return this.$store.state.user;
    },
    userSocietyObject: function () {
      return this.user && this.user.society ? this.user.society : null;
    },
    userSocietyName: function () {
      return this.userSocietyObject ? this.userSocietyObject.name : '';
    },
    userSpecialty: function () {
      return this.user && this.user.specialty_id
          ? this.user.specialty.title
          : '';
    },
    userSubspecialty: function () {
      return this.user && this.user.subspecialty_id
          ? this.user.subspecialty.title
          : '';
    },
    membershipTypeName: function () {
      if (!this.user || !this.user.society_membership_type_id) return '';
      return this.$store.getters.getMembershipTypeName(
          this.user.society_membership_type_id
      );
    },
    dateValue: function () {
      return this.$dayjs().format('MMM D, YYYY h:mm A');
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../sass/variables_mixins.scss';
.report-heading {
  background-color: $phairify_v2_color_primary_teal;
  color: #FFFFFF !important;
  height: 100px;
  margin: 0 !important;
}
</style>
